import request from "@/utils/request";

export const systemLog = (params) =>
  request({
    url: "/api/backend/system/log",
    method: "GET",
    params,
  });
